























































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl,
  IsMore,
} from "@root/lib/decorator";

import { TableExpandWithAccordionDecorator } from "@root/utils/modules/wtRecord/decorator";
import CustomTableScrollWrap from "@/components/custom/CustomTableScrollWrap/index.vue";
const wtK2Scan = namespace("scan");
const exportFile = namespace("export");
const root = namespace("root");
@Component({ components: { CustomTableScrollWrap } })
@pagination("getData", {
  pageSize: 50,
})
@SearchbarControl()
@loading()
@IsMore(true)
@TableExpandWithAccordionDecorator()
export default class wtK2Outbound extends Vue {
  @exportFile.Action exportStoreScanRecordByUpdateTime;
  @exportFile.Action exportStoreScanRecord;
  @wtK2Scan.Action queryStoreScanRecord;
  @wtK2Scan.Action updateStoreRecordStatus;
  @wtK2Scan.State outTypeList;
  @wtK2Scan.State marketList;
  @wtK2Scan.State inOutStatusList;
  @wtK2Scan.Getter outTypeListObj;
  @wtK2Scan.Getter marketListObj;
  @wtK2Scan.Getter inOutStatusListObj;
  @wtK2Scan.Getter scanTypeListObj;
  @wtK2Scan.State storeAreaObj;
  @wtK2Scan.State isK1Obj;
  // @wtK2Scan.State systemTypeObj;
  @wtK2Scan.State takeEffectObj;
  @wtK2Scan.Action queryInoutInventory;
  @root.State ddCodes;

  private isKaOptions: any[] = [];
  private form = {
    orgCode: "",
    tyreCode: "",
    ownerMobile: "",
    marketType: "",
    isWarrantyCard: "",
    status: undefined,
    updateDateTime: "",
    time: "",
    isKa: "",
    recordType: 1,
  };
  private dataList = [];
  private exportLoading = false;
  private total = 0;
  private isExportVisible = false;
  // private searchForm = {
  //   recordType: 1
  // };

  get searchParams() {
    let { time, updateDateTime, ...others } = this.form;
    let start = undefined;
    let end = undefined;
    if (time) {
      start = time[0];
      end = time[1];
    }
    let startUpdate = undefined;
    let endUpdate = undefined;
    if (updateDateTime) {
      startUpdate = updateDateTime[0];
      endUpdate = updateDateTime[1];
    }

    let input = {
      ...others,
      isKa: others.isKa === "" ? null : others.isKa,
      startTime: start || undefined,
      endTime: end || undefined,
      updateStartTime: startUpdate || undefined,
      updateEndTime: endUpdate || undefined,
    };
    return input;
  }

  get isCreatedwarrantyCard() {
    let result: any = {
      "0": "否",
      "1": "是",
    };
    return result;
  }

  payStatusMap: any = {};
  coordinateMap: any = {};
  ownerIdMap: any = {};
  payChannelMap: any = {};
  newOutTypeMap: any = {};
  filterOutTypeList: any = [];
  filterOutTypeMap: any = {};

  async mounted() {
    // await this.getData();
    this.queryInoutInventory();
    await this.$dd
      .register([
        "PAY_CHANNEL_TYPE",
        "COORDINATE_TYPE",
        "OWNER_ID_TYPE",
        "PAY_STATUS_TYPE",
        "NEW_SCAN_OUT_TYPE",
        "NEW_SCAN_TYPE_QUERY",
        "isKA"
      ])
      .query();
    console.log(this.ddCodes, "---this.ddCodes");
    this.newOutTypeMap = this.ddCodes.NEW_SCAN_OUT_TYPE_MAP;
    this.payChannelMap = this.ddCodes.PAY_CHANNEL_TYPE_MAP;
    this.coordinateMap = this.ddCodes.COORDINATE_TYPE_MAP;
    this.ownerIdMap = this.ddCodes.OWNER_ID_TYPE_MAP;
    this.payStatusMap = this.ddCodes.PAY_STATUS_TYPE_MAP;
    this.filterOutTypeList = this.ddCodes.NEW_SCAN_TYPE_QUERY;
    // this.filterOutTypeMap = this.ddCodes.NEW_SCAN_TYPE_QUERY_MAP;
    // this.filterOutTypeMap["4"] = "";
    // this.filterOutTypeMap["5"] = "";
    this.isKaOptions = this.ddCodes["isKA"] || [];
    console.log(this.filterOutTypeList, "---this.filterOutTypeList");
  }

  @loadingCatch
  async getData() {
    const { pageSize, currentPage: pageNum } = this as any;
    const pageInput = {
      pageSize,
      pageNum,
    };
    try {
      let input = this.searchParams;
      await this.timeLimitFn();
      let { total, list } = await this.queryStoreScanRecord({
        input,
        pageInput,
      });
      this.dataList = list.map((row) => {
        this.$set(row, "status", row.status);
        return row;
      });
      this.total = total;
    } catch (err) {
      console.error(err);
      this.total = 0;
    }
  }
  async cancelRecord(row) {
    await this.$confirm("你确定取消吗？", "", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    });
    await this.updateStoreRecordStatus({
      scanStoreUpdateInput: {
        recordCode: row.recordCode,
        orgCode: row.orgCode,
        tyreStatusInputList: [
          {
            status: 3,
            tyreCode: row.tyreCode,
          },
        ],
      },
    });
    row.status = 0;
    this.$message.success("取消成功");
  }
  /**
   * 根据条件判断
   * logo：入参有更新时间，logo：2。有更新时间+其他参数（非注释），logo：1
    orgCode: "",
    tyreCode: "",
    ownerMobile: "",
    marketType: "",
    isWarrantyCard: "",
    status: undefined,
    // updateDateTime: "",
    // time: "",
    // recordType: 1
   */
  async exportExcelFn() {
    const { searchParams: input } = this;
    await this.timeLimitFn();
    const {
      updateStartTime,
      updateEndTime,
      tyreCode,
      ownerMobile,
      marketType,
      isWarrantyCard,
      status,
    } = input;
    if (updateStartTime && updateEndTime) {
      let logo = "1";
      if (ownerMobile || tyreCode || marketType || status || isWarrantyCard) {
        logo = "1";
      } else {
        logo = "2";
      }
      await this.exportStoreScanRecordByUpdateTime({
        input,
        logo,
      });
    } else {
      await this.exportStoreScanRecord({
        input,
      });
    }
  }
  async timeLimitFn() {
    return new Promise((resolve, reject) => {
      const { searchParams: input } = this;
      const { orgCode, tyreCode, ownerMobile, startTime, updateStartTime } =
        input;
      if (
        !(orgCode || tyreCode || ownerMobile) &&
        !startTime &&
        !updateStartTime
      ) {
        this.$message.warning("请选择出库时间或更新时间！");
        reject(false);
        return false;
      } else {
        resolve(true);
        return true;
      }
    });
  }
}
